import { render, staticRenderFns } from "./DetailsSectionPaymentByLink.vue?vue&type=template&id=2501f2ce&"
import script from "./DetailsSectionPaymentByLink.vue?vue&type=script&lang=js&"
export * from "./DetailsSectionPaymentByLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports